import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "share-page" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["ChatInput"], {
        ref: "chat",
        shadow: "",
        controls: "",
        class: "chat-input",
        description: "Genrate can make mistakes. Consider checking important information."
      }, null, 512 /* NEED_PATCH */)
    ]),
    _createVNode($setup["ShareModal"])
  ], 64 /* STABLE_FRAGMENT */))
}